import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import Headers from './components/Headers';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import UserDetails from './pages/UserDetails';
import AttendanceReport from './pages/AttendanceReport';
import AttendanceExport from './pages/AttendanceExport';
import DeviceStatus from './pages/DeviceStatus';
import Login from './pages/Login';
import Reset from './pages/Reset';
import OdRecord from './pages/OdRecord';
import LeaveRecord from './pages/LeaveRecord';
import Register from './pages/Register';
import Update from './pages/Update';
import FaceScanner from './pages/FaceScanner';
import ApprovalRecords from './pages/ApprovalRecords';
import PayrollMaster from './pages/Payroll';

const Layout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';
  const isResetPage = location.pathname === '/reset';

  return (
    <>
      {!isLoginPage && !isResetPage && <Headers />}
      <div className='main d-flex'>
        {!isLoginPage && !isResetPage && (
          <div className='sidebarWrapper'>
            <Sidebar />
          </div>
        )}
        <div className='rightWrapper'>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/userdetails" element={<UserDetails />} />
            <Route path="/attendancereport" element={<AttendanceReport />} />
            <Route path="/attendanceexport" element={<AttendanceExport />} />
            <Route path="/devicestatus" element={<DeviceStatus />} />
            <Route path="/odrecord" element={<OdRecord />} />
            <Route path="/leaverecord" element={<LeaveRecord />} />
            <Route path="/register" element={<Register />} />
            <Route path="/update" element={<Update />} />
            {/* <Route path="/facescanner" element={<FaceScanner />} /> */}
            <Route path='/approvalrecords' element={<ApprovalRecords />} />
            <Route path='/payroll' element={<PayrollMaster />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;